import { useMutation } from "react-query";
import http from "infra/http";

function useDeletarItemRelatorioPrestacaoContas() {
  return useMutation(
    ({ id, itemId }: { id: string; itemId: string }) => {
      return http.delete(
        `/v1/relatorios/financeiro/prestacao-contas/${id}/item/${itemId}`
      );
    },
    { retry: false }
  );
}

export default useDeletarItemRelatorioPrestacaoContas;
